import React from 'react'
import { ButtonBase } from '@material-ui/core'
import * as css from '../User.styles'
export const CdrUsageButtons = () => {
    return (
        <>
            <ButtonBase
                className={css.button}
                onClick={(e) => {
                    console.log('exporting result')
                }}
                >
                USAGE
            </ButtonBase>
        </>
    )
}